import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-white py-16 sm:py-20" aria-labelledby="garantia-title" data-id="element-106" data-mp="4uqdmw6js2tb">
      <div className="mx-auto grid max-w-4xl items-start gap-8 px-5 sm:px-8 md:grid-cols-[auto_minmax(0,1fr)] md:gap-10" data-id="element-107" data-mp="9umkr4ajkad3">
        <span className="flex h-20 w-20 items-center justify-center rounded-full bg-sage-soft" data-id="element-108" data-mp="euh7qwr74fsv">
          <ShieldCheckIcon className="h-10 w-10 text-sage-deep" aria-hidden="true" data-id="element-109" data-mp="jrhezazs7olk" />
        </span>
        <div data-id="element-110" data-mp="nt2n6j1dfepf">
          <h2 id="garantia-title" className="font-display text-3xl font-extrabold leading-tight tracking-tight text-petrol sm:text-4xl" data-id="element-111" data-mp="nst5rjue6fvc">
            Probalo sin riesgo — 7 días de garantía total
          </h2>
          <div className="mt-6 space-y-4 text-lg leading-relaxed text-body" data-id="element-112" data-mp="12j0hlgpw90n2">
            <p data-id="element-113" data-mp="12gxh22r47p43">Descargás el MegaPack. Lo abrís. Lo usás en tu cocina.</p>
            <p className="font-semibold text-petrol" data-id="element-114" data-mp="17iwnjli5j259">
              Si en 7 días no es exactamente lo que esperabas, te devolvemos el 100% de tu dinero.
            </p>
            <p data-id="element-115" data-mp="20savgcpzdbpn">Sin formularios. Sin que tengas que justificar nada. Sin demoras.</p>
            <p data-id="element-116" data-mp="1vthhkj6s7ioy">
              Podemos hacer esa promesa porque sabemos lo que tenemos adentro. Tasa de devoluciones:
              menos del 1%.
            </p>
          </div>
          <p className="mt-6 border-l-4 border-sage pl-4 font-display text-xl font-bold text-petrol" data-id="element-117" data-mp="1ru8rboaya2y5">
            El único riesgo es seguir sin el sistema otro día más.
          </p>
        </div>
      </div>
    </section>;
}